import React from 'react';
import Route from './Route';

export default ({ ...props }) => <Route {...props} priv authorize />;
